// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.parentToggle .mat-button-toggle-checked {
    background-color: lightgray !important;
}

.parentToggle .mat-button-toggle {
    background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/objectcreator/measuredefinition/panels/parentreference/parentreference.control.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;AAC1C;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".parentToggle .mat-button-toggle-checked {\n    background-color: lightgray !important;\n}\n\n.parentToggle .mat-button-toggle {\n    background-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
